<template>
  <div
    :class="{ 'indexable-item__container': !disabled }"
    style="padding: 10px;"
  >
    <div class="indexable-item__title">
      <div>
        <span class="index-number__container">{{ index }}</span>
        <span class="index-title__container">{{ title }}</span>
      </div>
      <div
        v-if="isReadonly && !disabled"
        class="cursor-pointer"
        @click="remove"
      >
        <i class="far fa-times-circle text-red" />
      </div>
    </div>
    <div class="mt-2">
      <div
        v-if="isReadonly"
        :class="{
          'text-readonly__container-bordered': !isReadonly,
          'text-readonly__container': !disabled,
        }"
      >
        {{ value }}
      </div>
      <div v-else>
        <CustomTextArea v-model="model" :maxlength="10000" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'IndexableItem',
  components: {
    CustomTextArea,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: '',
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: '',
    };
  },
  watch: {
    value(newValue) {
      this.model = newValue;
    },
    model(newValue) {
      this.$emit('input', newValue);
    },
  },
  methods: {
    remove() {
      this.$emit('remove');
    },
  },
};
</script>

<style scoped>
.indexable-item__container {
  border-radius: 5px;
  background-color: #ffffff;
  background-color: white;
  border: 1px solid #c6cdcf;
}

.indexable-item__title {
  display: flex;
  justify-content: space-between;
}

.index-number__container {
  height: 25px;
  width: 25px;
  background-color: #ee7960;
  display: inline-block;
  border-radius: 5px;
  text-align: center;
  color: white;
}

.index-title__container {
  margin-left: 5px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

.text-readonly__container {
  padding: 10px;
}

.text-readonly__container-bordered {
  border-radius: 5px;
  border: 1px solid #c6cdcf;
}
</style>
